module.exports = __webpack_public_path__ + "img/gold_left.aa0b22c9.png";